/**
 * Tutor service — browse tutors, get tutor by ID.
 * Uses apiClient for auto-auth and base URL.
 */
import apiClient from './apiClient';

/**
 * Get all tutors with optional filters.
 */
export const getTutors = async (params = {}) => {
    const { search, subject, sort_by, user_lat, user_lng } = params;
    const queryParams = new URLSearchParams();

    if (search) queryParams.append('search', search);
    if (subject && subject !== 'all') queryParams.append('subject', subject);
    if (sort_by) queryParams.append('sort_by', sort_by);
    if (user_lat != null) queryParams.append('user_lat', user_lat);
    if (user_lng != null) queryParams.append('user_lng', user_lng);

    return apiClient.get(`/tutors?${queryParams.toString()}`);
};

/**
 * Get single tutor by ID.
 */
export const getTutorById = async (id) => {
    return apiClient.get(`/tutors/${id}`);
};

/**
 * Get reviews for a tutor.
 */
export const getTutorReviews = async (tutorId, skip = 0, limit = 10) => {
    return apiClient.get(`/tutors/${tutorId}/reviews?skip=${skip}&limit=${limit}`);
};

/**
 * Get ratings summary for a tutor.
 */
export const getTutorRatingsSummary = async (tutorId) => {
    return apiClient.get(`/tutors/${tutorId}/ratings-summary`);
};

/**
 * Add a review for a tutor (requires auth).
 */
export const addTutorReview = async (tutorId, reviewData) => {
    return apiClient.post(`/tutors/${tutorId}/reviews`, reviewData);
};
